export const citizenshipList = [
  { value: "3", label: "American" },
  { value: "2", label: "Canadian" },
  { value: "1", label: "Filipino" },
  { value: "12", label: "Korean" },
  { value: "19", label: "Others" },
];
export const civilStatusList = [
  { value: "1", label: "Single" },
  { value: "2", label: "Legally Separated / Widow(er)" },
  { value: "3", label: "Married" },
];

export const typeOfResidenceList = [
  { value: "9", label: "Boarder / Transient" },
  { value: "4", label: "Living with parents/relatives" },
  { value: "2", label: "Owned, Mortgaged" },
  { value: "1", label: "Owned, Unencumbered" },
  { value: "3", label: "Rented" },
];

export const educationList = [
  { value: "7", label: "College Graduate" },
  { value: "2", label: "College Undergraduate" },
  { value: "3", label: "Primary" },
  { value: "5", label: "Secondary" },
];

export const typeOfEmploymentList = [
  { value: "1", label: "Employed (Local)" },
  { value: "2", label: "Self-Employed (Local)" },
  { value: "3", label: "OCW/OFW" },
];

export const businessNatureList = [
  { value: "7", label: "-none-" },
  { value: "3", label: "Manufacturing and Processing" },
  { value: "2", label: "Services (including lease rentals)" },
  { value: "1", label: "Trading / Retailing" },
];

export const placeOfBusinessList = [
  { value: "6", label: "-none-" },
  { value: "2", label: "Outside Metro Manila" },
  { value: "1", label: "Within Metro Manila" },
];

export const sexList = [
  { value: "8", label: "Male" },
  { value: "9", label: "Female" },
];

export const loanTermList = [
  { value: "0", label: "0" },
  { value: "11", label: "1" },
  { value: "12", label: "2" },
  { value: "13", label: "3" },
  { value: "14", label: "4" },
  { value: "15", label: "5" },
  { value: "16", label: "6" },
  { value: "17", label: "7" },
  { value: "18", label: "8" },
  { value: "19", label: "9" },
  { value: "20", label: "10" },
  { value: "21", label: "11" },
  { value: "22", label: "12" },
  { value: "23", label: "13" },
  { value: "24", label: "14" },
  { value: "25", label: "15" },
  { value: "26", label: "16" },
  { value: "27", label: "17" },
  { value: "28", label: "18" },
  { value: "29", label: "19" },
  { value: "30", label: "20" },
  { value: "31", label: "21" },
  { value: "32", label: "22" },
  { value: "33", label: "23" },
  { value: "34", label: "24" },
  { value: "35", label: "25" },
  { value: "36", label: "26" },
  { value: "37", label: "27" },
  { value: "38", label: "28" },
  { value: "39", label: "29" },
  { value: "40", label: "30" },
];

export const loanPurposeList = [
  { value: "8", label: "Condominium Acquisition" },
  { value: "12", label: "House and Lot Acquisition" },
  { value: "1", label: "Home Improvement" },
  { value: "2", label: "Lot Acquisition" },
  { value: "3", label: "Home export Construction" },
  { value: "4", label: "Home Equity" },
  { value: "5", label: "Loan Refinancing/Loan Take Out" },
  { value: "6", label: "Reimbursement" },
  { value: "7", label: "Top-up Loan" },
];

export const collateralTypeList = [
  { value: "7", label: "Condominium Unit" },
  { value: "8", label: "House and Lot" },
  { value: "9", label: "Others" },
  { value: "10", label: "Vacant Lot" },
];

export const collateralUseList = [
  { value: "5", label: "-none-" },
  { value: "2", label: "Non-Primary Residence" },
  { value: "1", label: "Primary Residence" },
];

export const bankDepositList = [
  { value: "59", label: "-none-" },
  { value: "58", label: "Placements" },
  { value: "57", label: "Savings Account" },
];

export const rankPositionList = [
  { value: "1", label: "Executive" },
  { value: "2", label: "Managerial" },
  { value: "8", label: "NA" },
  { value: "4", label: "Rank and File" },
  { value: "3", label: "Supervisory" },
];

export const typeOfJobList = [
  { value: "13", label: "NA" },
  { value: "9", label: "Professional " },
  { value: "10", label: "Skilled " },
  { value: "11", label: "Unskilled " },
];

export const employmentStatus = [
  { value: "regular", label: "Regular" },
  { value: "probationary", label: "Probationary" },
  { value: "contractual", label: "Contractual" },
  { value: "consultant", label: "Consultant" },
];
